@let list = visibleList$ | async;
@let isSelectedAll = isSelectedAll$ | async;
@let isPartialSelection = isPartialSelection$ | async;
@let essentialSubscriptions = massSrv?.essentialSubscriptions$ | async;
@if (list?.length > 0 || emptyListKey) {
    <div
        scroll
        (scrollToBottom)="needNextPage$.next(true)"
        class="bazis-infinite-scroll-content"
    >
        @if (list?.length) {
            <div
                *transloco="let t"
                class="bazis-item bazis-checkbox"
                [ngClass]="{
                    'bazis-checkbox_mixed': isPartialSelection && !isSelectedAll,
                    'bazis-item--selected': isSelectedAll,
                }"
                (click)="toggleAll(list)"
            >
                <span class="bazis-checkbox__label">
                    {{ t('action.selectAll') }}
                </span>
            </div>

            <hr class="bh-margin-vertical-1x" />
        }

        @for (item of list; track item.id) {
            <!-- <ng-template
                [ngTemplateOutlet]="itemTpl"
                [ngTemplateOutletContext]="{ item: item }"
            ></ng-template> -->
            <bazis-multiple-selection-item
                [item]="item"
                [infiniteListTpl]="infiniteListTpl"
                [fieldForId]="searchSettings.fieldForId"
                [multiple]="true"
                [valuesMap]="valuesMap"
                (toggled)="toggleSelectedValue(getItemId(item))"
            ></bazis-multiple-selection-item>
        }

        @if (list?.length === 0 && emptyListKey) {
            <div class="bazis-item bh-events-none">
                {{ emptyListKey | transloco }}
            </div>
        }
    </div>
}
